<template>
  <div id="topics-dashboard" class="w-full" v-if="isCardActiveLocal">
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <user-details :loading="loadingDetails" :userDetails="userDetails" :myTime="userDetailsObject.timeSpentAvarageStudent" :avgTime="userDetailsObject.timeSpentAvarageClass" :radialData="[userDetailsObject.scoreAvarageStudent,userDetailsObject.scoreAvarageClass]"/>
      </div>
    </div>
    <div class="flex mb-2" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">Topics</h4>
      </div>
      <vx-input-group class="input-group-with-input-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <vs-input class="dashboard-filter-input" placeholder="Search here..." v-model="topicFilterText"/>
      </vx-input-group>
    </div>
    <div v-if="loadingDataCards && !terms.length" class="vx-row data-card-container">
      <div class="vx-col w-full mb-3" style="padding-left: 0; padding-right: 0;">
        <data-card-skeleton :count="4"/>
      </div>
    </div>
    <div v-for="(term, tindex) in terms" :key="tindex">
      <div class="vx-row">
        <div class="vx-col flex" style="align-items: center;">
          <span><feather-icon class="mr-3" icon="ClockIcon" svg-classes="stroke-current h-6 w-6"></feather-icon></span>
          <h5 style="margin-bottom: 0;" class="mr-4">{{term.name}}</h5>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
          <div v-if="!loadingDataCards" class="data-card-container flex" v-dragscroll @dragscrollstart="dragScollStart" @dragscrollend="dragScollEnd">
            <div v-for="(topic, index) in topics.filter(function(item){return item.moduleGroupId == term.id})" :key="index" >
              <data-card :smallText="true" type="Topic" class="mx-2" @handleClick="selectedTopic(topic)" :title="topic.name" :myTime="topic.myTime" :avgTime="topic.avgTime" :radialData="topic.radialData"/>
            </div>
          </div>
          <div v-if="loadingDataCards" class="vx-row data-card-container">
            <div class="vx-col w-full mb-3" style="padding-left: 0; padding-right: 0;">
              <data-card-skeleton :count="4"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsTime" @filterDropdownChanged="filterDropdownChangedStudentGraphTimeSpent" :series="timeSpentSeries" :title="'Time Spent'" :filterList="listOfTopicsForDropdown"/>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsScore" @filterDropdownChanged="filterDropdownChangedStudentGraphScore" :series="scoreSeries" :title="`Score`" :filterList="listOfTopicsForDropdown"/>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import DataCard from './DataCard.vue'
import UserDetails from './UserDetails.vue'
import CustomSkeleton from './CustomSkeleton.vue'
import DataCardSkeleton from './DataCardSkeleton.vue'
import LineChart from './LineChart.vue';
export default {
  name: "Topics",
  components: {
    vSelect,
    DataCard,
    UserDetails,
    CustomSkeleton,
    DataCardSkeleton,
    LineChart,
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    userDetails:{
      type:Object,
      required: true
    }
  },
  data() {
    return {
      loadingDetails:true,
      loadingDataCards:true,
      loadingChartsTime:true,
      loadingChartsScore:true,
      topics: [],
      terms: [{
        name:"TERM 1"
      }],
      originalTopics: [],
      topicFilterText: "",
      dragging: false,
      listOfTopicsForDropdown: [],
      listOfModulesForDropdown: [],
      scoreSeries:[],
      timeSpentSeries:[],
      userDetailsObject:{},
    };
  },
  watch: {
    isCardActive: function(val) {
      var self = this;
      if(val){
        self.getTopics();
        self.fetchUserDetails();
        localStorage.setItem("Teacher_Position",JSON.stringify(self.userDetails));
        localStorage.setItem("Active_Card","6");
      }
      if(!val){
        self.timeSpentSeries = [];
        self.scoreSeries = [];
      }
    },
    topicFilterText: function(val) {
      var self = this;
      if(val) {
        self.topics = self.originalTopics.filter(function(x) { return x.name.toLowerCase().includes(val.toLowerCase()) });
      } else {
        self.topics = self.originalTopics;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    getTopics() {
      var self = this;

      self.loadingDataCards = true;
      

      var onSuccess = function(response) {
        self.topics = [];
        response.data.forEach(element => {
          self.topics.push({
            id: element.topicId,
            moduleGroupId: element.termId,
            moduleGroupName: element.term,
            name: element.topic,
            myTime: element.timeSpentAvgStudent,
            avgTime: element.timeSpentAvgClass,
            radialData: [element.scoreAvgStudent, element.scoreAvgClass]
          });
        });
        self.listOfTopicsForDropdown = self.topics.map((item) => {return { label: item.name, value: item.id }});

        self.originalTopics = self.topics;

        var temp_terms = [];
        self.terms = [];
        temp_terms = self.topics.map(function(item) {
          return { id: item.moduleGroupId, name: item.moduleGroupName };
        });

        temp_terms.filter(function(item) {
          return self.topics.map(function(_topic) {
            return _topic.moduleGroupId; 
          }).includes(item.id);
        }).forEach(_term => {
          if (self.terms.filter(function(item) {
            return _term.id == item.id
          }).length == 0 && _term.id != null)
            self.terms.push(_term);
        });
        self.terms = self.terms.sort((a, b) => a.name > b.name ? 1 : -1); 
      };

      var onFinally = function() {
        self.loadingDataCards = false;
        self.loadingChartsTime = false;
        self.loadingChartsScore = false;
      };
      self.$ajaxGet(self, `PrincipalDashboard/GetStudentTopicAvg?classroomId=${this.userDetails.selectedClassroom.classroomId}&studentId=${this.userDetails.selectedStudent.studentId}&moduleCategoryId=${this.userDetails.selectedModule.moduleCategoryId}`, onSuccess, onFinally);
    },
    selectedTopic(topic){
      if (!this.dragging) {
        this.$emit('selectedTopic', topic);
        this.userDetails.selectedTopic = topic;
      }
    },
    dragScollStart(){
      this.dragging = false;
    },
    dragScollEnd(){
      this.dragging = true;

      setTimeout(() => {
        this.dragging = false;
      }, 50);
    },
    filterDropdownChangedStudentGraphTimeSpent(topicName,topicId,selectedDate) {
      var self = this;
      this.loadingChartsTime = true;
      var onSuccess = response =>{
        self.timeSpentSeries = [
          {
            name: `${self.userDetails.selectedStudent.displayName} Avg.`,
            data: response.data.avaragesList,
          },
          {
            name: `Class Avg.`,
            data: response.data.timeSpentAvaragesList
          }
        ];
      }
      var onFinally = response =>{
        self.loadingChartsTime = false;
      }
      self.$ajaxGet(self, `PrincipalDashboard/TimeSpentGraphAvg?studentId=${this.userDetails.selectedStudent.studentId}&month=${selectedDate.monthIndex}&year=${selectedDate.year}&classroomId=${this.userDetails.selectedClassroom.classroomId}&moduleCategoryId=${this.userDetails.selectedModule.moduleCategoryId}&moduleId=${topicId}` , onSuccess, onFinally);
    },
    filterDropdownChangedStudentGraphScore(topicName,topicId,selectedDate) {
      var self = this;
      this.loadingChartsScore = true;
      var onSuccess = response =>{
        self.scoreSeries = [
          {
            name: `${self.userDetails.selectedStudent.displayName} Avg.`,
            data: response.data.scoreList,
          },
          {
            name: `Class Avg.`,
            data: response.data.scoreListAvg,
          },
        ];
      }
    
      var onFinally = response =>{
        self.loadingChartsScore = false;
      }
      self.$ajaxGet(self, `PrincipalDashboard/AvgScore?studentId=${this.userDetails.selectedStudent.studentId}&month=${selectedDate.monthIndex}&year=${selectedDate.year}&classroomId=${this.userDetails.selectedClassroom.classroomId}&moduleCategoryId=${this.userDetails.selectedModule.moduleCategoryId}&moduleId=${topicId}` , onSuccess, onFinally);
    },
    fetchUserDetails() {
      var self = this;
      this.loadingDetails = true;
      var onSuccess = response =>{
        self.userDetailsObject = response.data;
        self.loadingDetails = false;
      }
      var onFinally = response =>{
        self.loadingDetails = false;
      }
      self.$ajaxGet(self, `PrincipalDashboard/UserDetails?studentId=${self.userDetails.selectedStudent.studentId}&classroomId=${this.userDetails.selectedClassroom.classroomId}&moduleCategoryId=${this.userDetails.selectedModule.moduleCategoryId}`, onSuccess, onFinally);
    },
  },
  created() {
  },
  mounted() {
  }
};
</script>

